<app-tooltip
    *ngIf="helpTextAvailable"
    trigger="<img src='./assets/shared/icons/help-i.svg' class='block' alt='help icon'>"
    [title]="title"
    [content]="content"
    [width]="width"
    [forceRight]="forceRight"
    [startDelay]="650"
    tabindex="0"
    class="help">
</app-tooltip>
